const uiColors = {

    background: "#0D0D22",

    gradient: "linear-gradient(90deg, #11CBE2, #2243B0, #7933E9)",

    gradientHover: "linear-gradient(90deg, #22E3FF, #2F5BFF, #8A4DFF)",
    topbarGradient: "linear-gradient(90deg, #2243B0, #11CBE2)",
    gradientVerticleBg: "linear-gradient(180deg, #2243B0, #11CBE2)",

    teal: "#11CBE2",
    textGradientTeal: "linear-gradient(90deg, #11CBE2, #0fbad1)",

    

    text: {
        primary: "#ffff",
        secondary: "#b0b3c7"
    },
    

    card: "#262644",
    inputBg: "#2a3441",

    cardGlow: "rgba(255,255,255,0.12)",

    iconBg: "#16213E",
    /* ------------------ Sidebar Colors ------------------ */
    sidebar: {
        itemColor: "#ffffff",
        itemHoverBg: "rgba(255,255,255,0.1)",
        itemSelectedBg: "rgba(255,255,255,0.2)",
        subItemColor: "#ffffff",
        subItemHoverBg: "rgba(255,255,255,0.15)",
        subItemSelectedBg: "rgba(255,255,255,0.25)",
    },
    skeleton: {
        baseColor: "#1A1A2E",
        highlightColor: "#2A2A3E",
    },

};

export default uiColors;